/**
 * <wishlist-page>: renders the saved products as server-rendered cards and
 * removes a card as soon as its heart is toggled off.
 */
import { events } from '@theme/core';
import { fetchCard } from '@theme/recently-viewed';

class WishlistPage extends HTMLElement {
  async connectedCallback() {
    this.grid = this.querySelector('[data-wishlist-grid]');
    this.empty = this.querySelector('[data-wishlist-empty]');
    this.summary = this.querySelector('[data-wishlist-summary]');

    const wishlist = await this.#wishlist();
    const handles = await wishlist.list();
    const cards = (await Promise.all(handles.map(fetchCard))).filter(Boolean);

    this.grid.replaceChildren(
      ...cards.map((card) => {
        const li = document.createElement('li');
        li.dataset.handle = card.dataset.cardFragment;
        li.append(...card.childNodes);
        return li;
      }),
    );
    this.grid.removeAttribute('aria-busy');
    this.#sync(cards.length);

    this.off = events.on('wishlist:updated', ({ items }) => {
      this.grid.querySelectorAll(':scope > li').forEach((li) => {
        if (items.includes(li.dataset.handle)) return;
        li.setAttribute('data-removing', '');
        setTimeout(() => {
          li.remove();
          this.#sync(this.grid.children.length);
        }, 250);
      });
    });
  }

  disconnectedCallback() {
    this.off?.();
  }

  /** wishlist.js is loaded by the layout; wait for it if needed. */
  async #wishlist() {
    for (let i = 0; i < 50 && !window.Theme?.wishlist; i++) await new Promise((r) => setTimeout(r, 50));
    return window.Theme.wishlist;
  }

  #sync(count) {
    this.empty.hidden = count > 0;
    this.summary.textContent = count > 0 ? this.summary.dataset.template.replace('[count]', count) : '';
  }
}

if (!customElements.get('wishlist-page')) customElements.define('wishlist-page', WishlistPage);
